<template>
  <AppSection class="links">
    <AppContainer>
      <h3 class="mb-4 flex items-center">
        {{ COMPANY_NAME }} {{ tCountry(baseCountry) }}
        <CountryFlag :code="baseCountry" class="mb-5" end />
      </h3>
      <AppThirdLayout reverse>
        <DesktopOnly tag="figure">
          <AppImg :src="officePicPath" />
          <figcaption>{{ addressText }}</figcaption>
        </DesktopOnly>
        <div class="flex col gap-6">
          <div>
            <h5>{{ $tt('about_page.location') }}</h5>
            <div class="flex">
              <AppIcon icon="mdi:map-marker-outline" color="primary" size="x-large" start />
              {{ addressText }}
            </div>
          </div>
          <div>
            <h5>{{ $tt('about_page.connect') }}</h5>
            <div class="flex gap-4">
              <SupportEmailLink>
                <AppIcon icon="mdi:email-outline" size="large" />
              </SupportEmailLink>
              <AppLink to="/contact">
                <AppIcon icon="mdi:chat-outline" size="large" />
              </AppLink>
              <PhoneLink>
                <AppIcon icon="mdi:phone-outline" size="large" />
              </PhoneLink>
              <WhatsappLink>
                <AppIcon icon="mdi:whatsapp" size="large" />
              </WhatsappLink>
              <a :href="telegram" target="_blank">
                <AppIcon icon="uil:telegram-alt" size="large" />
              </a>
            </div>
          </div>
          <div>
            <h5>{{ $tt('about_page.follow_us') }}</h5>
            <SocialLinks primary size="medium" />
          </div>
          <div>
            <h5>{{ $tt('about_page.legal') }}</h5>
            <div class="flex col items-start gap-2">
              <AppLink to="/privacy">{{ $tt('privacy_policy') }}</AppLink>
              <AppLink to="/terms">{{ $tt('terms_of_use') }}</AppLink>
              <p>{{ $tt(business.idTypeKey) }}: {{ business.number }}</p>
              <p v-if="business.owner">{{ business.owner }}</p>
            </div>
          </div>
        </div>
      </AppThirdLayout>
    </AppContainer>
    <MobileOnly tag="figure">
      <div class="office-img" :style="{ '--office-image': `url(${officePicPath})` }" />
      <AppContainer class="pt-4">
        <figcaption>{{ addressText }}</figcaption>
      </AppContainer>
    </MobileOnly>
  </AppSection>
</template>

<script setup lang="ts">
import { COMPANY_NAME } from '~/assets/constants';

const { addressText, telegram } = useCommunication();
const { baseCountry, officePicture, business } = useBranch();
const { tCountry } = useLocalization();
const officePicPath = '/images/office/' + officePicture;
</script>

<style scoped lang="scss">
figure {
  width: 100%;
  img {
    width: 100%;
    border-radius: var(--border-r-lg);
  }
}
.links {
  h5 {
    font-size: 20px;
    margin-bottom: var(--space-2);
  }
  p, a {
    font-size: 18px;
  }
}
@media (max-width: 850px) {
  h3 {
    font-size: 24px;
    justify-content: center;
  }
  .office-img {
    display: block;
    position: relative;
    height: 360px;
    background: linear-gradient(to bottom, white 0%, rgba(255, 255, 255, 0) 50%), var(--office-image);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>